module.exports = __webpack_public_path__ + "img/order.a5780492.jpg";